
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppInput, AppButton } from '@/components';
import { useDuplicateRank } from '@/modules/duplicate/cycle/item/model/rank';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.CYCLE.RANK,
    components: { AppTable, AppCard, AppFormRow, AppInput, AppButton },
    setup() {
        const { query, list, total, fetchList } = useDuplicateRank();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Account ID', key: 'accountId' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Value', key: 'value' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-users',
                        theme: 'info',
                        tooltip: 'Accounts',
                        to: { name: ROUTE_NAME_ACCOUNT.APP.DETAIL, params: { accountId: row.accountId } }
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { query, list, total, table, fetchList };
    }
});
